module.exports = __webpack_public_path__ + "r-v3/img/reset.6b2a5932.svg";